import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export function Redirect() {
	const { isAuthenticated } = useAuth();

	if (!isAuthenticated) {
		return <Navigate to="/auth/login" replace />;
	}

	return <Navigate to="/backoffice" replace />;
}
